import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'btn-cell-renderer-details-supplier',
    template: `
		<em *ngIf="enableDetails">
		<img style="cursor:pointer;" 
		src="./assets/images/info_black.svg" 
		(click)="btnClickedHandler('details')"> 
		</em>
		`,
    standalone: false
})
export class BtnCellRendererDetailsSupplier implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	enableDetails: boolean = false;
	enableDelete: boolean = false;
	enableEdit: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field

		//shipments
		if (this.params.colDef.field == "details") { // NOSONAR
			this.enableDetails = true;
			this.enableEdit = true;
			this.enableDelete = true;
		}

	}

	btnClickedHandler(action) {

		if (action == 'details') { // NOSONAR
			this.params.context.componentParent.detailsTemplateRow(this.params.data, this.pageName);

		}

	}

	ngOnDestroy() {
		console.info('something')
	}
}
